import React from "react";
import { Grid } from "@mui/material";
import Label from "../../../../common/components/Label";
import SingleSelectDropDown from "../../../../common/components/SingleSelectDropDown";
import TextBox from "../../../../common/components/Textbox";
import { useDispatch, useSelector } from "react-redux";
import { setCampaignName, setCurrency, setErrorMessages, setMaxExperience, setMaxSalary, setMinExperience, setMinSalary, setSalaryRange } from "../../../../redux/slice/campaignSlice";
import { RootState } from "../../../../redux/store";
import SalaryRange   from "@foundit/salaryRange/dist/SalaryRange";
import {ISalaryRange}  from "@foundit/salaryRange/dist/types/salaryRange";
import "@foundit/salaryRange/dist/SalaryRange.css";
import { getCurrencyBasedOnSiteContext } from "../../../../utils/helpers";
import { unFormatNumberString } from "../../../../utils/whatsAppUtils";
import { defaultErrorMsg } from "../../../../utils/utils";
import CommonTooltip from "../../../../common/components/CommonTooltip";


// type Option = {
//   label: string;
//   value: string;
// }

const getExperienceOptions = (minEx: string, maxEx: string, generatingMaxEx: boolean) => {
  const EXPERIENCE_OPTIONS = Array(51).fill('').map((_, index) => {
    const labelString = `${index} ${index < 2 ? 'Year' : 'Years'}`;
    let isDisabled = false;
    if (generatingMaxEx && minEx && Number(minEx) > index) {
      isDisabled = true;
    }
    if (!generatingMaxEx && maxEx && Number(maxEx) < index) {
      isDisabled = true;
    }
    return {
      label: labelString,
      value: (index).toString(),
      isDisabled: isDisabled
    }
  })
  return EXPERIENCE_OPTIONS
}


const RightSideJob = () => {
  const dispatch = useDispatch();
  const minExperience = useSelector((state: RootState) => state.campaign.minExperience);
  const maxExperience = useSelector((state: RootState) => state.campaign.maxExperience);
  const minSalary = useSelector((state: RootState) => state.campaign.minSalary);
  const maxSalary = useSelector((state: RootState) => state.campaign.maxSalary);
  const campaignName = useSelector((state: RootState) => state.campaign.campaignName);
  const errorMessages = useSelector((state: RootState) => state.campaign.errorMessages);
  const currency = useSelector((state: RootState) => state.campaign.currency);
  const siteContext = useSelector((state: RootState) => state.campaign.userData.siteContext);

  const isSeaAndGulf = siteContext === 'rexmonster' ? false : true;
  const triggeredFromPage = useSelector((state: RootState) => state.campaign.campaignCreationQueryData.triggeredFromPage);
  const { minExp, maxExp } = useSelector(
  (state: RootState) => state.campaign.disabledFields
);
 const isMinExpLocked =
  triggeredFromPage === 'SRP' && minExp
   const isMaxExpLocked =
  triggeredFromPage === 'SRP' && maxExp

  React.useEffect(() => {
    // if(siteContext === 'rexmonster') return;
    if(!currency){
      const defaultCurrency = getCurrencyBasedOnSiteContext(siteContext);
      dispatch(setCurrency({currency: defaultCurrency}));
    }
  },[currency, dispatch, siteContext])
  

  const handleJobDetailsFeildChange = React.useCallback((value: string, type: string) => {
    if (type === 'minSalary' && minSalary !== undefined) {
   
      dispatch(setMinSalary({ minSalary: value }));
      
      // if(errorMessages.salary && (Number(minSalary) < Number(maxSalary))){
      //   dispatch(setErrorMessages({ errorMessages: { salary: '' } }));
      // }
    }
    else if (type === 'maxSalary') {
      dispatch(setMaxSalary({ maxSalary: value }));
      if(errorMessages.salary && ( Number(minSalary) < Number(maxSalary))){
        dispatch(setErrorMessages({ errorMessages: { salary: '' } }));
      }
    }
    else if (type === 'minExp') {
      dispatch(setMinExperience({ minExperience: value }));
      if (errorMessages.minExp) {
        dispatch(setErrorMessages({ errorMessages: { minExp: '' } }));
      }
    }
    else if (type === 'maxExp') {
      dispatch(setMaxExperience({ maxExperience: value }));
      if (errorMessages.maxExp) {
        dispatch(setErrorMessages({ errorMessages: { maxExp: '' } }));
      }
    }
    else if( type === 'currency') {
      dispatch(setCurrency({currency: value}));
    }
    else {
      dispatch(setCampaignName({ campaignName: value }));
      if (errorMessages.campaignName) {
        dispatch(setErrorMessages({ errorMessages: { campaignName: '' } }));
      }
    }
  }, [dispatch, errorMessages.campaignName, errorMessages.maxExp, errorMessages.minExp, errorMessages.salary, maxSalary, minSalary])

  const handleUpdateSalaryRange = (salaryRange: ISalaryRange) => {
    dispatch(setSalaryRange({ salaryRange }));

    if(salaryRange?.min && salaryRange?.max && +unFormatNumberString(salaryRange?.min) <= +unFormatNumberString(salaryRange?.max)){
      dispatch(setErrorMessages({ errorMessages: { salary: '' } }));
    }
  }

  const handleBlur = () =>{
    if (minSalary && maxSalary && +unFormatNumberString(minSalary) > +unFormatNumberString(maxSalary)) {
      dispatch(setErrorMessages({ errorMessages: { salary: defaultErrorMsg.salaryRange } }));
    }else {
      dispatch(setErrorMessages({ errorMessages: { salary: '' } }));
    }
  }

  return (<>
    <Grid
      xs={12}
      display='flex'
      item
      alignItems='center'
      gap={'0.4rem'}
    >
      <Grid container rowGap='0.5rem' xs={6.5}>
        <Label
          label="Min experience"
          labelFor="minExp"
          required
          colorType="light"
          subLabel="(Year)"
        />
        <Grid container alignItems={'center'}>
          <Grid item xs={12}>
            <CommonTooltip
                    width='270px'
                    title={isMinExpLocked ?  'Search filters cannot be edited during campaign setup.' : ''} 
                    customZIndex={99999999}
                    offset={[40,10]}
                    arrowShift={'35px'}
                    >
            <div style={{width:'100%'}}>
            <SingleSelectDropDown
              handleChange={(e) => handleJobDetailsFeildChange(e.target.value as string, 'minExp')}
              id="minExp"
              label="label"
              listItems={getExperienceOptions(minExperience, maxExperience, false)}
              value='value'
              placeholder="Select"
              selectedValue={minExperience}
              showError={Boolean(errorMessages.minExp)}
              errorMessage={errorMessages.minExp}
              isDisabled={isMinExpLocked}
            />
            </div>
            </CommonTooltip>
          </Grid>
        </Grid>
      </Grid>
   
    <Grid container rowGap='0.5rem' xs={5.5}>
      <Label
        label="Max experience"
        labelFor="maxExp"
        required
        colorType="light"
        subLabel="(Year)"
      />
      <CommonTooltip
              width='270px'
              title={isMaxExpLocked ?  'Search filters cannot be edited during campaign setup.' : ''} 
              customZIndex={99999999}
              offset={[40,10]}
              arrowShift={'58px'}
              >
      <div style={{width:'100%'}}>
      <SingleSelectDropDown
        handleChange={(e) => handleJobDetailsFeildChange(e.target.value as string, 'maxExp')}
        id="maxExp"
        label="label"
        listItems={getExperienceOptions(minExperience, maxExperience, true)}
        value='value'
        selectedValue={maxExperience}
        placeholder="Select"
        showError={Boolean(errorMessages.maxExp)}
        errorMessage={errorMessages.maxExp}
        isDisabled={isMaxExpLocked}
      />
      </div>
      </CommonTooltip>
    </Grid>
    </Grid>
    {/* <Grid item xs={12} display='flex'
      alignItems='center'
      gap={'0.4rem'}
    >
     {isSeaAndGulf  ? <Grid container rowGap='0.5rem' xs={4}>
        <Label
          label="Currency"
          labelFor="currency"
          colorType="light"
        />
            <SingleSelectDropDown
              handleChange={(e) => handleJobDetailsFeildChange(e.target.value as string, 'currency')}
              id="currency"
              label="label"
              value='value'
              listItems={currencyList}
              selectedValue={currency}
              placeholder="Select"
            />
      </Grid>
    : null  
    }
      <Grid container rowGap='0.5rem' xs={isSeaAndGulf ? 4.5 : 6.5}>
        <Label
          label="Min salary"
          labelFor="minSal"
          colorType="light"
          subLabel={isSeaAndGulf ? "(Monthly)" : "(Annual)"}
        />
        <Grid container alignItems={'center'}>
          <Grid item xs={12}>
          <Autocomplete<Option>
              options={SALARY_RANGE}
              getOptionLabel={(option) => formatNumberWithCommas(option.label, isSeaAndGulf)}
              onChange={(e, value) => {
                if (value?.value && isValidSalaryValue(value?.value, maxSalary, true)) {
                  let sal = formatNumberWithCommas(value.value, isSeaAndGulf)
                  handleJobDetailsFeildChange(sal as string, 'minSalary');
                } else {
                  handleJobDetailsFeildChange('' as string, 'minSalary');
                }
              }}
              renderInput={(params) => 
             <InputNumber isSeaAndGulf={isSeaAndGulf}  params={params} placeholder="Min" error={Boolean(errorMessages.salary)} helperText={errorMessages.salary}/>
            }
              filterOptions={(options, params) => {
                const filtered = options.filter((option) => {
                       // Filter out disabled options
                  if (isSalaryOptionDisabled(option, maxSalary, true)) return false;

                  if (!params.inputValue.trim()) {
                    return true;
                  }
                  return  option.label.toLowerCase().includes(params.inputValue.toLowerCase());
                });

                if (params.inputValue !== '') {
                  let val = params.inputValue
                  if(params.inputValue.length > 7){
                    val = val.slice(0,7)
                  }
                  if(isValidSalaryValue(val, maxSalary, true)){
                    filtered.push({
                    label: val,
                    value: val || '0',
                  });
                }
                }

                return filtered;
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container rowGap='0.5rem' xs={isSeaAndGulf ? 3.5 : 5.5}>
        <Label
          label="Max salary"
          labelFor="maxSal"
          colorType="light"
          subLabel={isSeaAndGulf ? "(Monthly)" : "(Annual)"}
          whiteSpace='nowrap'
        />
         <Grid container alignItems={'center'}>
          <Grid item xs={12}>
            <Autocomplete<Option>
              options={SALARY_RANGE}
              getOptionLabel={(option) => formatNumberWithCommas(option.label, isSeaAndGulf)}
              // getOptionDisabled={(option) =>
              //   minSalary !== null && minSalary === '>2000000' ? parseInt(option.value) <= 2000000 :
              //     parseInt(option.value) <= parseInt(minSalary)
              // }
              onChange={(e, value) => {
                if (value?.value && isValidSalaryValue(value.value, minSalary, false)) {
                  let sal = formatNumberWithCommas(value.value, isSeaAndGulf)
                  handleJobDetailsFeildChange(sal as string, 'maxSalary');
                } else {
                  handleJobDetailsFeildChange('' as string, 'maxSalary');
                }
              }}
              renderInput={(params) =>
                <InputNumber isSeaAndGulf={isSeaAndGulf} params={params} placeholder="Max" error={Boolean(errorMessages.salary)}/>
              }
              filterOptions={(options, params) => {
                const filtered = options.filter((option) => {
                  if (isSalaryOptionDisabled(option, minSalary, false)) return false;
                  if (!params.inputValue.trim()) {
                    return true;
                  }
                  return option.label.toLowerCase().includes(params.inputValue.toLowerCase());
                });

                if (params.inputValue !== '') {
                  let val = params.inputValue
                  if(params.inputValue.length > 7){
                    val = val.slice(0,7)
                  }
                 if(isValidSalaryValue(val, minSalary, false)) {
                  filtered.push({
                    label: val,
                    value: val || '0',
                  });
                }
                }

                return filtered;
              }}
            />
          </Grid>
          </Grid>
      </Grid>
    </Grid> */}
    <Grid item container xs={12} rowGap='0.5rem' >
      <SalaryRange 
        currencyList={[]}  
        handleUpdateSalaryRange={handleUpdateSalaryRange} 
        salaryRange={{
          currency, min : minSalary || "", max: maxSalary || ""
        }} 
        error={errorMessages.salary}
        onBlur={handleBlur}
      />
    </Grid>
    <Grid item container xs={12} rowGap='0.5rem' >
      <Label
        label="Campaign name"
        labelFor="campaignName"
        required
        colorType="light"
      />
      <TextBox
        placeholder="Campaign name"
        textValue={campaignName}
        handleChange={(e) => handleJobDetailsFeildChange(e.target.value as string, 'campaignName')}
        id='companyName'
        showError={Boolean(errorMessages.campaignName)}
        errorMessage={errorMessages.campaignName}
      />
    </Grid>
  </>)
}

export default RightSideJob;